<div class="separator">
    <slot></slot>
</div>

<style>
    @import "../main.css";

    .separator {
        @apply reset px-4 pb-1 pt-2 text-xs text-gray-500 !important;
    }
</style>
